import { getTeamsQueryKey } from '../../hooks/api/teams/useTeams';
import queryClient from '../../ReactQuery/client';
import { get, put, remove } from '../api';
import teamActions from '../teams/actions';
import type { SetUserTeamRolesRequest } from '../../../typings/api';
import type { User } from '../../types';

export const UPDATE_USER_PERMISSION = 'UPDATE_USER_PERMISSION';
export const UPDATE_USER_ENABLED = 'UPDATE_USER_ENABLED';
export const SET_USER_TEAM_ROLES = 'SET_USER_TEAM_ROLES';
export const UPDATE_USER = 'UPDATE_USER';
export const FETCH_ALL_USERS = 'FETCH_ALL_USERS';
export const FETCH_ONE_USER = 'FETCH_ONE_USER';
export const DELETE_USER = 'DELETE_USER';
export const CREATE_USER = 'CREATE_USER';

const userActions = {
  fetchAll: () => ({
    type: FETCH_ALL_USERS,
    async payload() {
      return get(`/api/users/minimal`, true, {
        includeRole: true,
      });
    },
  }),
  fetchOne: (userId: number) => ({
    type: FETCH_ONE_USER,
    meta: {
      id: userId,
    },
    async payload() {
      return get(`/api/users/${userId}`, true);
    },
  }),
  update: (user: User) => ({
    type: UPDATE_USER,
    async payload() {
      return put(`/api/users/${user.id}`, user);
    },
  }),
  delete: (userId: number) => {
    return {
      type: DELETE_USER,
      meta: {
        userId,
      },
      async payload() {
        return remove(`/api/users/${userId}`);
      },
    };
  },
  updatePermission: (userId: number, roleId: number | null) => ({
    type: UPDATE_USER_PERMISSION,
    meta: { roleId },
    async payload() {
      return put(`/api/user/${userId}/permission`, { roleId });
    },
  }),
  updateEnabled: (userId: number | string, enabled: boolean) => ({
    type: UPDATE_USER_ENABLED,
    async payload() {
      return put(`/api/user/${userId}/enabled`, { enabled });
    },
  }),
  setTeamRoles: (userId: number | string, newRoles: SetUserTeamRolesRequest) => async (dispatch) => {
    dispatch({
      type: `${SET_USER_TEAM_ROLES}_PENDING`,
      meta: { userId },
    });
    try {
      await put(`/api/user/${userId}/team-roles`, newRoles);
    } catch (errResponse) {
      dispatch({
        type: `${SET_USER_TEAM_ROLES}_REJECTED`,
        meta: { userId },
        payload: errResponse,
      });
      return;
    }
    newRoles.forEach(newRole => {
      dispatch(teamActions.setTeamUserRole({ ...newRole, userId: Number(userId) }));
    });
    dispatch({
      type: `${SET_USER_TEAM_ROLES}_FULFILLED`,
      meta: { userId, newRoles },
    });

    //  We've moved some of the teams fetching into react-query, so we need to invalidate the cache/trigger a refetch.
    //  We probably don't *need* to do this, but we'll do it for the time being just to be safe.
    queryClient.invalidateQueries({
      queryKey: getTeamsQueryKey,
    });
  },
};

export default userActions;
